import { sanitizeFilterQueryValue } from './sanitizeFilterQueryValue';

/**
 * Joins a free-text search value with `q` DSL clauses into a single identity
 * query, dropping the search term when sanitization empties it.
 */
export function buildSearchFilterQuery(
  search: string,
  filters: string[],
): string {
  return [sanitizeFilterQueryValue(search), ...filters]
    .filter(Boolean)
    .join(' & ');
}
